// extracted by mini-css-extract-plugin
module.exports = {"base":"Back_base_2uQLS"};